// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97f292ad","455":"fc90261f","488":"e2ea4d6b"}[chunkId] + ".chunk.js";
};